var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-footer',{attrs:{"color":"teal darken-1","fixed":"","dark":"","elevation":"24"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © City of Bremerton "+_vm._s(new Date().getFullYear())+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }